"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createHashHistory = _interopRequireDefault(require("history/createHashHistory"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let history = (0, _createHashHistory.default)();
var _default = history;
exports.default = _default;